import { render, staticRenderFns } from "./LawMatterEvidenceList.vue?vue&type=template&id=1bda004c&"
import script from "./LawMatterEvidenceList.vue?vue&type=script&lang=js&"
export * from "./LawMatterEvidenceList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterEvidenceList.vue?vue&type=style&index=0&id=1bda004c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports